import {TranslatedLanguage} from 'hubbl-shared';
import Danish from './translations/da';
import English from './translations/en';

const localeMapper = (deviceLanguage: string): TranslatedLanguage => {
  if (deviceLanguage.startsWith(TranslatedLanguage.Danish)) {
    return TranslatedLanguage.Danish;
  } else if (deviceLanguage.startsWith(TranslatedLanguage.English)) {
    return TranslatedLanguage.English;
  } else {
    return TranslatedLanguage.English;
  }
};

const getBrowserLanguage = (): TranslatedLanguage => {
  // Get browser language from navigator.language

  const browserLanguage =
    navigator.language || navigator.languages?.[0] || 'en';
  return localeMapper(browserLanguage);
};

const getInitialLanguage = (): TranslatedLanguage => {
  // Priority: localStorage -> browser language -> English default
  const savedLanguage = localStorage.getItem('preferredLanguage');
  if (savedLanguage && (savedLanguage === 'da' || savedLanguage === 'en')) {
    return savedLanguage as TranslatedLanguage;
  }
  return getBrowserLanguage();
};

const getI18n = (locale?: TranslatedLanguage) => {
  switch (locale) {
    case TranslatedLanguage.Danish: {
      return Danish;
    }
    default:
    case TranslatedLanguage.English: {
      return English;
    }
  }
};

export {localeMapper, getI18n, getBrowserLanguage, getInitialLanguage};
